import LocationBase from './base/LocationBase';

/**
 * @class Location
 * @extends LocationBase
 */
class Location extends LocationBase {

}

export default Location;
